/* */ 
(function(Buffer) {
  'use strict';
  var Promise = require('../util/promise');
  module.exports = {
    order: 100,
    allowEmpty: true,
    canParse: '.json',
    parse: function parseJSON(file) {
      return new Promise(function(resolve, reject) {
        var data = file.data;
        if (Buffer.isBuffer(data)) {
          data = data.toString();
        }
        if (typeof data === 'string') {
          if (data.trim().length === 0) {
            resolve(undefined);
          } else {
            resolve(JSON.parse(data));
          }
        } else {
          resolve(data);
        }
      });
    }
  };
})(require('buffer').Buffer);
